import React, { useEffect, useState } from 'react'
import styles from "../Corpus/corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import "../../App.css"
import 'rc-calendar/assets/index.css'
import Calendar from 'rc-calendar'
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import CustomSelect from '../../Components/CustomSelect'
import { ToastContainer, toast } from 'react-toastify';
import UnitStyles from "../MilUnit/MilUnit.module.css"
import 'react-toastify/dist/ReactToastify.css'
import MillUnitList from '../../Components/MilUnitList'

export default function Battalion() {
    const [battalion, setBattalion] = useState("")
    const [battalions, setBatalions] = useState([])
    const [milUnits, setMilUnits] = useState([])
    const [change, setChange] = useState(null)
    const [mil, setMil] = useState("")
    const [defenseArea, setDefenseArea] = useState("") 
    const [coordinates, setCoordinates] = useState("")
    const [place, setPlace] = useState("")
    const [chief, setChief] = useState("")
    const [name, setName] = useState("")
    const [startDate, setStartDate] = useState("");
    const [showStartDate, setShowStartDate] = useState(false);
    const [showEndDate, setShowEndDate] = useState(false);
    const [endDate, setEndDate] = useState("");
    const [loading, setLoading] = useState(false)
    const [clear, setClear] = useState(false)
    const [corpuses, setCorpuses] = useState([])
    const [corpusNum, setCorpusNum] = useState()
    const [isMillUnitShown, setMillUNitShown] = useState(false)
    const [search, setSearch] = useState("")

    useEffect(() => {
            (async() => {
                const corpuses = await axiosInstance.get('admin/corpuses')
                if(corpuses.status){
                    setCorpuses(corpuses.data.data)

                }
            })()
        }, [])

    useEffect(() => {
        (async() => {
            const milunits = await axiosInstance.get('admin/milunits')
            if(milunits.status){
                setMilUnits(milunits.data.data)
            }
        })()
    }, [])

    useEffect(() => {
           (async() => {
               const batalions = await axiosInstance.get('admin/battalions')
               if(batalions.status){
                setBatalions(batalions.data.data)
               }
           })()
       }, [])


    const submitHandler = async () => {
        if(!battalion){
            toast.error("Գումարտակի համարը պարտադիր է");
            return;
        }
        if(!name){
            toast.error("Գումարտակի անվանումը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.post('admin/battalion', {battalion_number: battalion, battalion_unit: mil.trim() ? mil : null, defense_area: defenseArea, coordinates: coordinates, place: place, chief: chief, name: name, startDate, endDate})
        if(res.data.status){
            setMil("")
            setBattalion("")
            setBatalions([...battalions, res.data.data])
            setDefenseArea("")
            setCoordinates("")
            setPlace("")
            setChief("")
            setName("")
            setStartDate("")
            setEndDate("")
            toast.success("Գումարտակը հաջողությամբ ավելացվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

    const changeMilUnit = async (el) => {
        setChange(el)
        setBattalion(el.battalion_number)
        setMil(el.battalion_unit)
        setDefenseArea(el.battalion_defenseArea)
        setCoordinates(el.battalion_coordinates)
        setPlace(el.battalion_place)
        setChief(el.battalion_chief)
        setName(el.battalion_name)
        setStartDate(el.battalion_startDate)
        setEndDate(el.battalion_endDate)
    }

    const changeHandler = async () => {
        if(!battalion){
            toast.error("Գումարտակի համարը պարտադիր է");
            return;
        }
        if(!name){
            toast.error("Գումարտակի անվանումը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.put(`admin/battalion/${change._id}`, {battalion_number: battalion, battalion_unit: mil.trim() ? mil : null, defense_area: defenseArea, coordinates: coordinates, place: place, chief: chief, name: name, startDate, endDate})
        if(res.status){
            setChange(null)
            setBatalions(p => {
                let index = battalions.findIndex(el => el._id === change._id)
                const newCorpuses = [...battalions]
                newCorpuses[index] = {...res.data.data}
                return newCorpuses
            })
            setBattalion("")
            setDefenseArea("")
            setCoordinates("")
            setStartDate("")
            setEndDate("")
            setMil("")
            setPlace("")
            setChief("")
            setName("")
            toast.success("Գումարտակը հաջողությամբ փոփոխվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

      function getDate(date){
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        const formattedDate = new Date(date).toLocaleDateString('hy-AM', options);
        return formattedDate;
      }
    
      const handleStartDateModal = (e) => {
        e.stopPropagation();
        setShowEndDate(false)
        setShowStartDate(!showStartDate);
      }
    
      const handleEndDateModal = (e) => {
        e.stopPropagation();
        setShowStartDate(false)
        setShowEndDate(!showEndDate);
      }
    
      const closeCalendars = () => {
        setShowStartDate(false);
        setShowEndDate(false);
      }
    
      const am={
        today: 'Այսօր',
        now: 'Այժմ',
        backToToday: 'Վերադառնալ այսօր',
        ok: 'Հաստատել',
        clear: 'Մաքրել',
        month: 'Ամիս',
        year: 'Տարի',
        timeSelect: 'Ընտրել ժամ',
        dateSelect: 'Ընտրել ամսաթիվ',
        monthSelect: 'Ընտրել ամիս',
        yearSelect: 'Ընտրել տարի',
        decadeSelect: 'Ընտրել տասնամյակ',
        yearFormat: 'YYYY',
        dateFormat: 'D-M-YYYY',
        dayFormat: 'D',
        dateTimeFormat: 'D-M-YYYY HH:mm:ss',
        monthBeforeYear: true,
        previousMonth: ' Նախորդ ամիս (PageUp)',
        nextMonth: '  Հաջորդ ամիս (PageDown)',
        previousYear: ' Նախորդ տարի (Control + left)',
        nextYear: '  Հաջորդ տարի (Control + right)',
        previousDecade: ' Նախորդ տասնամյակ',
        nextDecade: '  Հաջորդ տասնամյակ',
        previousCentury: ' Նախորդ դար',
        nextCentury: '  Հաջորդ դար',
      }

      const deleteBattalion = async (el) => {
        const res = await axiosInstance.delete(`admin/battalion/${el._id}`)
        if(res.data.status){
            setBatalions(p => p.filter(battalion => battalion._id !== el._id))
        }
        toast.success("Գումարտակը հաջողությամբ ջնջվեց");
      }



      

  return (
    <div className={styles["corpus-main-div"]} onClick={closeCalendars}>
        <div className={`${styles["corpus-container"]} w-2/3`}>
            <h2>Լրացրեք գումարտակի տվյալները</h2>
            <div className='grid grid-cols-2 gap-5'> 
                <div>
                    <label htmlFor="corpusNumber">Գումարտակի համար</label>
                    <input type="number" id="corpusNumber" value={battalion} onChange={(e) => setBattalion(e.target.value)} />
                </div>
                <div>
                    <label htmlFor="corpusNumber">Գումարտակի անվանում</label>
                    <input type="text" id="corpusNumber" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                    <div>
                    <label htmlFor="place">Բնակավայր</label>
                    <input type="text" id="place" value={place} onChange={(e) => setPlace(e.target.value)}  />
                </div>
                <div >
                    <label htmlFor="defenseArea">Պաշտպանական շրջան</label>
                    <input type="text" id="defenseArea" value={defenseArea} onChange={(e) => setDefenseArea(e.target.value)}  />
                </div>
                <div>
                    <CustomSelect 
                        defaultValueForInput={mil}
                        options={milUnits.map((el,i) => <option key={i} value={el._id}>{el.unit_number}</option>)}
                        callback={setMil}
                        label="Ընտրել զորամասը"
                        clear={clear}
                    />
                </div>
                <div>
                    <label htmlFor="chief">Պատասխանատու</label>
                    <input type="text" id="chief" value={chief} onChange={(e) => setChief(e.target.value)} />
                </div>
            </div>
            <div>
                <p className={`${styles["terms"]} text-center`}>Մ/հ-ում գտնվելու ժամկետը</p>
                <div className={styles["dates"]}>
                <div className={styles["from"]}>
                    <div onClick={handleStartDateModal} className={styles["flex"]}>
                        <input type="text" value={startDate ? startDate : "Սկիզբ"} disabled/>
                        <FontAwesomeIcon icon={faCalendarDays} className={styles["calendar-icon"]}/>
                    </div>
                    {showStartDate && <Calendar locale={am} style={{position: "absolute"}} onChange={e => setStartDate(getDate(e._d))} value={startDate} showDateInput={showStartDate} className={styles["calendar"]}/>}
                    </div>
                    -
                    <div className={styles["to"]}>
                    <div onClick={handleEndDateModal} className={styles["flex"]}>
                        <input type="text" value={endDate ? endDate : "Ավարտ"} disabled/>
                        <FontAwesomeIcon icon={faCalendarDays} className={styles["calendar-icon"]}/>
                    </div>
                    {showEndDate && <Calendar locale={am} style={{position: "absolute"}} onChange={e => setEndDate(getDate(e._d))} value={endDate} className={styles["calendar"]}/>}
                    </div>
                </div>
            </div>
            <div className='w-3/5 mx-auto'>
                <button className={`confirm-btn`} disabled={loading} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
            </div>
        </div>
        <div className={UnitStyles["corpus-list"]}>
            <div className='relative'>
                <h2>Գումարտակներ</h2>
                <input type="text" placeholder='Փնտրել...' className="absolute border border-black/40 p-1 rounded-md top-0 left-4" onChange={(e) => setSearch(e.target.value)}/>
            </div>
                {!search ? corpuses.map((el, index) => {
                    return (
                        <li key={index} className={UnitStyles["corpus-list-items"]}>
                            <p className='text-center cursor-pointer' onClick={() => {setCorpusNum(el._id);setMillUNitShown(!isMillUnitShown)}}>{el?.corpus_number + " " + el?.corpus_name}</p>
                            {isMillUnitShown && corpusNum === el._id  && <MillUnitList millUnits={milUnits} corpusNumber={el?._id} battalions={battalions} changeMilUnit={changeMilUnit} deleteBattalion={deleteBattalion} />}
                        </li>
                    )
                }) : <ol>
                            <li className={styles["corpus-list-item"]}>
                                <p className='per3 start'>Գումարտակի համար/Անվանում</p>
                                <p className='per3'>Զորամաս</p>
                                <p className='per3 end'>Ղեկավարման կոճակներ</p>
                            </li>
                            {battalions?.filter(el => el.battalion_number.includes(search) || el.battalion_name.includes(search)).map((el, index) => {
                                return <li key={index} className={styles["corpus-list-item"]}>
                                        <p className='per3 start'>{`${el?.battalion_number ? el?.battalion_number + " " : ""}${el?.battalion_name ? el?.battalion_name : ""}`}</p>
                                        <p className='per3'>{el.battalion_unit.unit_number}</p>
                                        <div className='per3 end'>
                                            <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => changeMilUnit(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                            <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => deleteBattalion(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                                        </div>
                                    </li>
                            })}
                        </ol>}
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
